<div class="item-menu">
	<span class="btn-icon-circle btn-circle-md-lower btn-circle-light btn-circle-effects"
		  (click)="fermerContact()"
		  tooltip="Fermer le contact"
		  placement="bottom"
		  container="body"
		  data-e2e="fermer-le-contact">
		<i class="icon-delete"></i>
	</span>
</div>